import { refractor } from 'refractor';

function daml(Prism: any) {
  Prism.languages.daml = {
    comment: {
      pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\/].*|$)|\{-[\s\S]*?-\})/m,
      lookbehind: true,
    },
    char: {
      pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
      alias: 'string',
    },
    string: {
      pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
      greedy: true,
    },
    'import-statement': {
      pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: true,
      inside: {
        keyword: /\b(?:as|hiding|import|qualified)\b/,
        punctuation: /\./,
      },
    },
    keyword: /\b(?:abort|agreement|assert|case|choice|class|controller|data|deriving|do|else|ensure|fetch|fetchByKey|for|from|if|import|in|infixl|infixr|instance|interface|key|let|lookupByKey|maintainer|module|newtype|nonconsuming|observer|of|postconsuming|preconsuming|return|signatory|template|then|to|type|where|with)\b/,
    builtin: /\b(?:AcsDelta|Any|AnyException|Archive|Bool|ContractId|Date|Decimal|Either|False|Int|Integer|List|Map|None|Optional|Ordering|Party|Some|Text|Time|True|Update|abs|all|and|any|append|archive|compare|concat|concatMap|create|createAndExercise|createCmd|createInterface|debug|div|elem|empty|exercise|exerciseByKey|exerciseCmd|exerciseInterface|exerciseInterfaceByKey|fetch|fetchByKey|fetchInterface|filter|foldl|foldr|fromSome|getTime|head|length|lookup|lookupByKey|map|mapA|max|member|min|mod|null|or|otherwise|return|reverse|signatory|sort|tail|toAny|toInterfaceContractId|toParties|trace|undefined|upure|when)\b/,
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
    operator: [
      {
        pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
        greedy: true,
      },
      {
        pattern: /(\s)\.(?=\s)/,
        lookbehind: true,
      },
      /[-!#$%*+=?&@|~:<>^\\/][-!#$%*+=?&@|~.:<>^\\/]*|\.[-!#$%*+=?&@|~.:<>^\\/]+/,
    ],
    'class-name': {
      pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
      inside: {
        punctuation: /\./,
      },
    },
    variable: {
      pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
      inside: {
        punctuation: /\./,
      },
    },
    punctuation: /[{}[\];(),.:]/,
  };
}

daml.displayName = 'daml';
daml.aliases = ['dl'];

if (!refractor.registered('daml')) {
  refractor.register(daml);
}
